import React from "react";
import classes from "./Main.module.css";
import Movies from "../components/Movies/Movies";
import Carousel from "../components/Movies/Carousel";
import Search from "../components/Movies/Search";

const Main = props => {
  const { searching, keyword } = props;
  let content = (
    <React.Fragment>
      <Carousel />
      <div className={classes.Main}>
        <h1>Popüler Filmler</h1>
        <Movies />
      </div>
    </React.Fragment>
  );
  if (searching) {
    content = <Search keyword={keyword} />;
  }
  return content;
};

export default Main;
